import { IconProps } from './IconProps';

export const IconCheckRoundedEdges = ({ size = 14, color = '#344054', ...rest }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M12.3333 1L4.99999 8.33333L1.66666 5" stroke={color} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
